import { AspectRatio } from 'react-aspect-ratio';
import styled from 'styled-components';
import { VideoRenderer as CoreVideoRenderer } from 'core';

export const SharedVideoSlot = styled.div<{ $variant: 'lottie' | 'brand' }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    min-height: 0;
    align-self: stretch;
    ${({ $variant }) =>
        $variant === 'brand'
            ? `
        flex: 1;
    `
            : `
        flex: 1;
        min-width: 0;
    `}
`;

export const SharedVideoFrame = styled.div`
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
`;

export const SharedVideoAspectRatio = styled(AspectRatio)`
    width: 100%;
    height: 100%;
`;

export const SharedVideoRenderer = styled(CoreVideoRenderer)`
    border-radius: 4px;
`;
